import { combineReducers } from 'redux';
import { app } from './app';
import { loginState } from './auth';
import { machinesConfig } from './settings';
import { user } from './user';
import { currentOrganisation, organisations } from './organisations';
import { devices } from './devices';
import { activeAlarms, completedAlarms } from './alarms';
import machines from './machines';
import halls from './halls';
import users from './users';
import telemetry from './telemetry';
import alarmsConfig from './alarmsConfig';

const snunergy = combineReducers({
  activeAlarms,
  alarmsConfig,
  app,
  completedAlarms,
  currentOrganisation,
  devices,
  halls,
  loginState,
  machines,
  machinesConfig,
  organisations,
  telemetry,
  user,
  users,
});

export default snunergy;



// WEBPACK FOOTER //
// ./src/reducers/index.js